import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import {
  API_HOST_SARS,
  API_HOST_USERS,
  API_HOST_GUIDANCE,
  API_HOST_REFDATA,
  API_HOST_COMMS,
  API_HOST_FOI,
} from "../config";
import { BusinessService } from "./BusinessService";
import { SarsService } from "./SarsService";
import sarsStatusLookups from "./json/sarsStatusLookups.json";
import { UserService } from "./UserService";
import { GuidanceService } from "./GuidanceService";
import { ShareService } from "./ShareService";
import { refDataEndpoints, RefDataService } from "./RefDataService";
import sarsContactMethodLookups from "./json/sarsContactMethodLookups.json";
import sarsTypeLookups from "./json/sarsTypeLookups.json";
import sarsCategoryLookups from "./json/sarsCategoryLookups.json";
import sarsPauseEventsLookups from "./json/sarsPauseEventsLookups.json"
import { FoiService } from "./FoiService";

export const businessService = new BusinessService(API_HOST_USERS);
export const sarsService = new SarsService(API_HOST_SARS);
export const usersService = new UserService(API_HOST_USERS);
export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);

export const sarsStatusService = new LocalLookupService(sarsStatusLookups);
export const sarsContactMethodService = new LocalLookupService(
  sarsContactMethodLookups
);
export const sarsPauseEventLookupService = new LocalLookupService(sarsPauseEventsLookups);
export const sarsTypeService = new LocalLookupService(sarsTypeLookups);
export const sarsCategoryService = new LocalLookupService(sarsCategoryLookups);

//import reference data
export const countryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.countryOptions
);
export const shareService = new ShareService(API_HOST_COMMS);

export const foiService = new FoiService(API_HOST_FOI);
